// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { createSelector } from '@ngrx/store';
import { accessManagementSelector } from '../index';

export const selectGroups = createSelector(accessManagementSelector, (state) => state.groups);

// export const selectGroupDetails = createSelector(accessManagementSelector, state => state.groupDetails);



// WEBPACK FOOTER //
// ./src/app/access-management/state/groups/groups.selectors.ts